import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import { Search } from '@mui/icons-material';
import { tokens } from '../../../theme/tokens';

interface DiscoveryBannerProps {
  suggestionCount: number;
  onAcceptAll: () => void;
  onDismiss: () => void;
}

/** Shown after Re-discover: nothing changes until the store accepts. */
const DiscoveryBanner: React.FC<DiscoveryBannerProps> = ({ suggestionCount, onAcceptAll, onDismiss }) => (
  <Box
    sx={{
      display: 'flex',
      alignItems: 'center',
      gap: 1.5,
      flexWrap: 'wrap',
      px: 2,
      py: 1.625,
      bgcolor: tokens.accent.tint,
      border: '1px solid',
      borderColor: tokens.accent.border,
      borderRadius: '12px',
    }}
  >
    <Search sx={{ fontSize: 18, color: tokens.accent.main, flex: '0 0 auto' }} />
    <Typography sx={{ flex: '1 1 280px', fontSize: 13, color: tokens.ink.body }}>
      <Box component="span" sx={{ fontWeight: 700 }}>Discovery found {suggestionCount} Shopify Product Type suggestions</Box>
      {' '}from your store. They&apos;re marked in Motzu Classification Overrides; nothing changes until you accept.
    </Typography>
    <Button variant="contained" onClick={onAcceptAll} sx={{ height: 34, borderRadius: '9px', fontWeight: 600 }}>Accept all</Button>
    <Button onClick={onDismiss} sx={{ fontWeight: 600, color: tokens.ink.muted }}>Dismiss</Button>
  </Box>
);

export default DiscoveryBanner;
